import React from "react";

import Checkbox from "material-ui/Checkbox";
import FlatButton from "material-ui/FlatButton";

const fieldsName = {
  issueNumber: "Issue Number",
  location: "Location",
  description: "Description",
  assignTo: "Assign To",
  dueDate: "Due Date",
  cost: "Cost Amount",
  schedule: "Schedule​ Impact",
  status: "Status",
  images: "Images",
  issueTitle: "Issue Title",
};

const validator = obj => {
  const MAX_LENGTH = 6;
  const checkedFields = Object.values(obj).filter(val => val);

  return checkedFields.length >= MAX_LENGTH;
};

class TemplatesChoiceFields extends React.Component {
  state = {
    fields: this.props.reportFields,
    haveError: false
  };

  onChangeField = type => {
    const { typeReport } = this.props;
    const { fields } = this.state;
    if (!fields[type] && validator(fields) && typeReport === "table") {
      return;
    }
    this.setState({ fields: { ...fields, [type]: !fields[type] } }, () => {
      this.props.onSetReportFields(this.state.fields);
    });
  };

  onSetDefault = () => {
    const { defaultFields, typeReport } = this.props;
    this.props.onSetReportFields({ ...defaultFields[typeReport] });
  };

  static getDerivedStateFromProps(props, state) {
    return { ...state, fields: props.reportFields };
  }

  render() {
    const { defaultFields, typeReport } = this.props;
    const { fields } = this.state;

    const keyFieldsOrdering = Object.keys(defaultFields[typeReport]);
    const message = validator(fields) && typeReport === "table";
    return (
      <div>
        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          Report Fields
        </div>
        <div style={{ position: "relative" }}>
          {message && (
            <div
              className="template-creator-info template-creator-info-select"
              style={{
                textAlign: "center",
                position: "absolute",
                fontWeight: "bold",
                marginBottom: "10px",
              }}
            >
              For Table Report maximum number of fields 6
            </div>
          )}
        </div>
        <div style={{ display: "flex" }}>
          <div>
            <div>
              {keyFieldsOrdering.map(key => (
                <div
                  key={key}
                  onClick={() => this.onChangeField(key)}
                  style={{
                    display: "flex",
                    width: "150px",
                    padding: "10px",
                    cursor: "pointer"
                  }}
                >
                  <Checkbox
                    checked={fields[key]}
                    style={{ width: "30px" }}
                    iconStyle={{ fill: "#6da92e" }}
                  />
                  <div style={{ width: "200px" }}>{fieldsName[key]}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div>
          <FlatButton label="Set Default" onClick={this.onSetDefault} />
        </div>
      </div>
    );
  }
}

export default TemplatesChoiceFields;
